module.exports = __webpack_public_path__ + "img/five-thirds-red.8c6b1951.png";